import NotificationsPage from "@/pages/portal/notifications";
import SuspensionsPage from "@/pages/portal/suspensions/SuspensionsPage";
import RoleGuard from "@/pages/role-guard";
import { Permissions } from "@/utils/permissions";
import { lazy } from "react";
import { makeHandle } from "./router.helpers";

const PortalPage = lazy(() =>
  import("@/pages/portal").then((m) => ({ default: m.PortalPage })),
);

const FaqsPage = lazy(() =>
  import("@/pages/portal/faqs").then((m) => ({ default: m.FaqsPage })),
);

export const createPortalRoutes = () => ({
  path: "portal",
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          permissions={[Permissions.faqs.read, Permissions.announcements.read]}
          canHaveSomePermissions
        >
          <PortalPage />
        </RoleGuard>
      ),
      handle: makeHandle({ label: "Portal" }),
    },
    {
      path: "preguntas-frecuentes",
      element: (
        <RoleGuard permissions={[Permissions.faqs.read]}>
          <FaqsPage />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Portal", path: "/portal" },
        { label: "Preguntas frecuentes" },
      ),
    },
    {
      path: "notifications",
      element: (
        <RoleGuard permissions={[Permissions.announcements.read]}>
          <NotificationsPage />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Portal", path: "/portal" },
        { label: "Notificaciones Generales" },
      ),
    },
    {
      path: "plazos-de-suspension",
      element: (
        <RoleGuard
          permissions={[
            Permissions["node-deadline-suspensions-config"].read,
            Permissions["tags"].read,
          ]}
        >
          <SuspensionsPage />
        </RoleGuard>
      ),
      handle: makeHandle(
        { label: "Portal", path: "/portal" },
        { label: "Plazos de Suspensión" },
      ),
    },
  ],
});
